import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../../components/Card/Card';
import Icon from '../../../components/Icon/Icon';
import ICONS from '../../../components/Icon/IconPaths';

class YourAccount extends Component {
  render() {
    return (
        <div>
          <Link to="/settings" className="mb-4 d-flex align-items-center">
            <Icon icon={ICONS.ARROW_LEFT} size="12" className="Icon --Green-base" />
            <p className="caption --Green-base ml-2 my-0">Back</p></Link>
          <h1 className="mt-0 mb-4">Il tuo account</h1>
          <Link to="/subscription">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Gestisci abbonamento</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
          <Link to="/payment-details">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Informazioni pagamento</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
          <Link to="/personal-information">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Informazioni personali</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
          <a href="/home">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Log out</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.LOG_OUT} className="Icon --Green-base" />
              </div>
            </Card>
          </a>
          <a href="/home">
            <Card className="--Red-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Delete Account</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.DELETE} className="Icon --Red-base" />
              </div>
            </Card>
          </a>
        </div>
    );
  }
}

export default YourAccount;